module.exports = __webpack_public_path__ + "images/default_images/default_event_thumbnail.9afd40.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/default_images/default_event_thumbnail.png
// module id = 554
// module chunks = 4